export const USAGE_WARNING_THRESHOLD = 0.8;

export const secToMin = (sec) => Math.round((sec / 60) * 10) / 10;

export const fmtResetDate = (dateStr) => {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

export const weekdayFromEndDate = (endDate) => {
  if (!endDate) return "Monday";
  const d = endDate instanceof Date ? endDate : new Date(endDate);
  if (Number.isNaN(d.getTime())) return "Monday";
  return d.toLocaleDateString("en-US", { weekday: "long" });
};

export const deriveUsageState = (raw) => {
  if (!raw) return null;
  const isPro = String(raw.SubscriptionType || "").trim() === "Pro";
  const usedMin = secToMin(raw.UtilizeSecond || 0);
  const totalMin = isPro
    ? null
    : raw.MinuteFree > 0
      ? raw.MinuteFree
      : secToMin(raw.FreeSecond || 0);
  const remainingMin =
    totalMin !== null ? Math.round(Math.max(totalMin - usedMin, 0) * 10) / 10 : null;
  const resetsOn = fmtResetDate(raw.EndDate);
  const planLabel = isPro
    ? `ZT Pro${raw.SubscriptionPeriod ? ` (${raw.SubscriptionPeriod})` : ""}`
    : "Free Plan";
  const balanceDays = raw.BalanceDays ?? null;
  const endDate = raw.EndDate ? new Date(raw.EndDate) : null;
  const isActive = String(raw.Status || "").trim() === "Active";
  return {
    isPro,
    isActive,
    usedMin,
    totalMin,
    remainingMin,
    resetsOn,
    planLabel,
    balanceDays,
    endDate,
    subscriptionPeriod: raw.SubscriptionPeriod || "",
  };
};

export const computeBannerState = (usage) => {
  if (!usage) return null;
  if (usage.isPro) return null;
  if (usage.totalMin == null || usage.totalMin <= 0) return null;

  const ratio = usage.usedMin / usage.totalMin;
  if (ratio < USAGE_WARNING_THRESHOLD) return null;

  return {
    severity: ratio >= 1 ? "limit-reached" : "approaching",
    usedMinutes: Math.round(usage.usedMin),
    totalMinutes: Math.round(usage.totalMin),
    resetDay: weekdayFromEndDate(usage.endDate),
  };
};
